import React from 'react';

import { getPageComputationIndexes } from '@gitbook/hive-core';
import { assertNever } from '@gitbook/util-ts';

import { useHiveRevision } from './useHiveRevision';

/**
 * Return the original computed page that generate the given object (page, file, reusable content)
 * It returns `null` if the object is not computed.
 */
export function useHiveComputedOrigin(input: {
    objectType: 'pages' | 'reusable-contents' | 'files';
    objectId: string;
}) {
    const { computations } = useHiveRevision();

    return React.useMemo(() => {
        const indexes = getPageComputationIndexes(computations);

        switch (input.objectType) {
            case 'pages':
                return indexes.pagesOriginIndex.get(input.objectId);
            case 'reusable-contents':
                return indexes.reusableContentsOriginIndex.get(input.objectId);
            case 'files':
                return indexes.filesOriginIndex.get(input.objectId);
            default:
                assertNever(input.objectType);
        }
    }, [computations, input.objectId, input.objectType]);
}
